import { Component, EventEmitter, Output } from '@angular/core';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'm-geo-carousel',
  templateUrl: './m-geo-carousel.component.html',
  styleUrls: ['./m-geo-carousel.component.scss']
})
export class MGeoCarouselComponent extends Carousel {
  @Output() navigateRequest = new EventEmitter<number>();

  onButtonClick(conversionTypeId: number): void {
    this.navigateRequest.emit(conversionTypeId);
  }
}
